import { ingenuity } from "@quest/base-core";
import { Model } from "@quest/murka-games-behavior-leopard/dist"
import { GameParserModel } from "../Platform/GameParserModel";

export class BaseGameModel extends Model {
   private featureSequence: string[] = ["stackSymbolBg","showFlowerTrail", "showCollectedFlower","showWildDragonsOnReel","showPurpleToGoldenWild","checkForNoWin", "checkForWinAfterReelStop"];
   private featureSequenceCounter: number = 0;

   constructor(serverModel: any) {
      super(serverModel)
      this.setAnimationSequence([ "showAllFrames", "bigWin", "firstToggle", "triggeringAnimation", "selectFreeGame", "freeSpin", "sendCloseRequest"]);
   }
   //data related to feature sequence
   public getFeatureSequence(): string[] {
      return this.featureSequence;
   }
   //data related to feature sequence
   public resetFeatureSequenceCounter() {
      this.featureSequenceCounter = 0;
   }
   //data related to feature sequence
   public updateFeatureSequenceCounter() {
      this.featureSequenceCounter++;
   }
   //data related to feature sequence
   public getFeatureSequenceCounter() {
      return this.featureSequenceCounter;
   }

   getHasEnoughBalance(): boolean {
      return (this.serverModel.getBalance() + (ingenuity.parserModel as GameParserModel).getFreeBalance()) >= this.getTotalBet();
   }

}

